// import store from '@/store';
// import { leaseType } from '@/util/dictList.js';
export const option = {
  height: 'calc(100vh - 90px)',
  tip: false,
  searchShow: false,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchIcon: true,
  menu: false,
  column: [],
};

export const listByDateColumn = [
  {
    label: '代理商',
    prop: 'fullName',
  },
  {
    label: '产品类型',
    prop: 'productName',
  },
  {
    label: '租率',
    prop: 'lengingRate',
  },
  {
    label: '租赁人',
    prop: 'name',
  },
  {
    label: '租赁金额',
    prop: 'lengingAmount',
  },
]

export const mailOrderListColumn = [
  {
    label: '所属代理商',
    prop: 'businessDeptName',
  },
  {
    label: '车牌号',
    prop: 'carFirstNumber',
  },
  {
    label: '租赁人',
    prop: 'name',
  },
  {
    label: '创建日期',
    prop: 'lendingTime',
  },
  {
    label: '滞留时间',
    prop: 'residenceTime',
  },
]

